import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';

@Component({
  selector: 'app-document-verification-popup',
  templateUrl: './document-verification-popup.component.html',
  styleUrls: ['./document-verification-popup.component.scss']
})
export class DocumentVerificationPopupComponent {
parsedHeaders: { [key: string]: any } = {};
  headerKeys: string[] = [];
  parsedTables: any[] = [];
  submitting = false;

  constructor(
    private dialogRef: MatDialogRef<DocumentVerificationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private pRequestService: PortRequestFormServiceService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const rawData = this.data.parsed_data || {};
    
    // Bind dynamic headers & dynamic keys
    this.parsedHeaders = rawData.headers || {};
    this.headerKeys = Object.keys(this.parsedHeaders);

    // Bind dynamic tables
    this.parsedTables = rawData.tables || [];
  }

  /**
   * Dynamically gets up to 4 primary header items for the top banner
   */
  get summaryHeaderItems(): { key: string; value: any }[] {
    return this.headerKeys.slice(0, 4).map(key => ({
      key: key,
      value: this.parsedHeaders[key] || 'N/A'
    }));
  }

  addRow(table: any): void {
    const newRow: any = {};
    (table.columns || []).forEach((col: string) => {
      newRow[col] = '';
    });
    table.rows.push(newRow);
  }

  removeRow(table: any, index: number): void {
    table.rows.splice(index, 1);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.submitting = true;

    const finalPayload = {
      file_id: this.data.file_id,
      doc_type: this.data.doc_type, 
      parsed_data: {
        document_title: this.data.parsed_data.document_title || 'Document',
        headers: this.parsedHeaders,
        tables: this.parsedTables
      }
    };

    this.pRequestService.confirmParsedDocument(finalPayload).subscribe({
      next: () => {
        this.submitting = false;
        this.toastr.success('Document verified and saved to database successfully!');
        this.dialogRef.close(true);
      },
      error: () => {
        this.submitting = false;
        this.toastr.error('Failed to confirm document data');
      }
    });
  }
}
